module.exports = __webpack_public_path__ + "img/deezer.abdda907.svg";